<template>
  <section class="gf-custom-sort">
    <div class="gf-custom-sort__types">
      <custom-select
        v-model="selectedType"
        :options="optionTypes"
        position="left"
        @input="onSelectedTypeChange"
      />
    </div>
    <div class="gf-custom-sort__direction">
      <button
        class="btn btn-sm"
        @click="onDirectionClick"
      >
        <i
          class="gf-icon"
          :class="directionButtonIcon"
        ></i>
      </button>
    </div>
  </section>
</template>

<script>
import CustomSelect from '@shared/shared-components/shared/custom-select';

export default {
  name: 'GfCustomSort',
  components: { CustomSelect },
  props: {
    optionTypes: {
      type: Array,
      default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'ASC'
    },
    selectedSort: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      selectedType: null,
      selectedDirection: null
    };
  },
  computed: {
    directionButtonIcon() {
      return this.selectedDirection === 'ASC' ? 'gf-icon-sort-asc' : 'gf-icon-sort-desc';
    }
  },
  watch: {
    selectedSort() {
      if (this.selectedSort.key) {
        this.selectedType = this.optionTypes.find((type) => type.key === this.selectedSort.key);
        this.selectedDirection =
          this.selectedSort.value?.length > 0
            ? this.selectedSort.value
            : this.selectedType.defaultDirection;
      }
    }
  },
  mounted() {
    this.selectedType = this.optionTypes[0];
    this.selectedDirection = this.selectedType.defaultDirection;
  },
  methods: {
    onDirectionClick() {
      this.changeDirection();
      this.submitSorting();
    },
    onSelectedTypeChange() {
      this.selectedDirection = this.selectedType.defaultDirection;
      this.submitSorting();
    },
    changeDirection() {
      if (this.selectedDirection === 'ASC') {
        this.selectedDirection = 'DESC';
      } else {
        this.selectedDirection = 'ASC';
      }
    },
    submitSorting() {
      this.$emit('submit', {
        key: this.selectedType.key,
        value: this.selectedDirection
      });
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-custom-sort';

#{$this} {
  height: fit-content;
  min-height: 42px;
  display: flex;

  @include theme.md {
    min-height: 36px;
  }

  #{$this}__types {
    min-width: 175px;

    @include theme.md {
      min-width: 220px;
    }

    .vs__dropdown-toggle {
      min-height: 42px;
      padding: 0 0 5px;
      background-color: var(--light);
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      @include theme.md {
        min-height: 36px;
      }
    }
    .vs__search {
      padding: 0;
    }
    .vs__dropdown-menu {
      background-color: var(--light);
    }
  }
  #{$this}__direction {
    display: flex;
    align-items: center;
    border: 1px solid var(--border-color);
    border-left: none;
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--light);

    & > button {
      color: var(--text-muted);

      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
